"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hide = hide;
exports.hideElement = hideElement;
var _context = require("../context");
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Resize IFrame Handler
 * - resizes the SDK iframe
 *
 * @module core-bootstrap-command-hide
 */

/**
* Hides the SDK Iframe DOM element
*
* @param {*} id The iframe ID
*/
function hide(id) {
  var iframeEntry = (0, _context.getIframeConfiguration)(id);
  if (!iframeEntry) {
    return;
  }
  hideElement(iframeEntry.element);
}

/**
 * Hides a DOM element
 *
 * @param {*} element The DOM element to hide
 */
function hideElement(element) {
  element.style.display = 'none';
  element.style.borderWidth = '0px';
  element.style.borderStyle = 'none';
  element.style.minWidth = '100%';
}
//# sourceMappingURL=hide.js.map